(function(){
    'use strict';
    angular.module('app').controller('SendEmailModalController', SendEmailModalController);
    SendEmailModalController.$inject = [
        '$uibModalInstance',
        'AccountingService',
        'billingId',
        '$location',
        'toastr'
    ];

    function SendEmailModalController(
        $uibModalInstance,
        AccountingService,
        billingId,
        $location,
        toastr
    ) {
        const vm = this;
        vm.attachmentOptions = ['CSV', 'PDF', 'BOTH'];
        vm.send = send;
        vm.cancel = cancel;

        function send(){
            vm.sendingEmail = true;
            AccountingService.CustomerBilling.sendEmail(function(result) {
                vm.sendingEmail = false;
                toastr.success('Billing has been sent to the customer', 'Success');
                $location.path('/accounting-billing');
            }, function(error) {
                vm.sendingEmail = true;
                toastr.error(error.message || 'Try again', 'Unable to send email to customer');
            }, billingId, {type: vm.attachment.toLowerCase() === 'both' ? '' : vm.attachment.toLowerCase()});
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/accounting/modals/SendEmailModalController.js